import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import PlaybookDetailPage from '../playbooks/PlaybookDetailPage';
import AgentPage from './AgentPage';
import { isPlaybookId } from './playbookId';

/** /agents/:id — a playbook by its id, or a workspace agent by its kind. */
export function AgentOrPlaybook() {
  const { playbookId } = useParams();
  return isPlaybookId(playbookId) ? <PlaybookDetailPage /> : <AgentPage />;
}

/** The agents' earlier address, /ai-agents/…, kept so old links still land. */
export function LegacyAiAgentsRedirect() {
  const { pathname, search } = useLocation();
  return <Navigate to={`${pathname.replace(/^\/ai-agents/, '/agents')}${search}`} replace />;
}
